import React from 'react';

import { translate } from 'helpers/translateHelper';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import PropTypes from 'prop-types';

const LimitNotApplicable = ({ timeSeries, setOffsetModalId }) => {
    return (
        <div className='content-container' id={timeSeries?.uniqId}>
            <div className='d-flex justify-content-center align-items-center py-4 limit-not-applicable'>
                <p>{translate('ABB.Powertrain.Frontend.limitConfugurationNotApplicable')}
                    {timeSeries?.offset ? <>&nbsp;{translate('ABB.Powertrain.Frontend.limitConfigEditOffsetFromActionMenu')}</> :
                        <>  {translate('ABB.Powertrain.Frontend.clickTo')}
                            <GeneralButton
                                type='discreet'
                                className='limit-not-applicable-offset-button'
                                text={translate('ABB.Powertrain.Frontend.editOffset')}
                                onClick={() => { setOffsetModalId(timeSeries?.uniqId); }}
                            />.
                        </>}
                </p>
            </div>
        </div>
    );
};
LimitNotApplicable.propTypes = {
    timeSeries: PropTypes.shape({
        uniqId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        offset: PropTypes.any,
    }),
    setOffsetModalId: PropTypes.func,
};
export default React.memo(LimitNotApplicable);
